import { afterRenderEffect, ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { AuthService } from '../auth.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { Platform } from '@angular/cdk/platform';
import { PaintDirective } from '../paint.directive';
import { LocationService } from '../location.service';

@Component({
  selector: 'package-checkout-confirm',
  standalone: true,
  imports: [RouterLink, MatIconModule, MatDividerModule, MatButtonModule, PaintDirective],
  templateUrl: './package-checkout-confirm.component.html',
  styleUrl: './package-checkout-confirm.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export default class PackageCheckoutConfirmComponent {
  protected auth = inject(AuthService);
  activated = inject(ActivatedRoute);
  router = inject(LocationService);

  isIOS = inject(Platform).IOS;

  on_cooldown = signal<boolean>(false);
  attempts = signal<number>(0);
  state = computed(() => {
    const user_package = this.auth.userSession()?.package;
    return user_package == this.activated.snapshot.queryParams.p ? 'upgraded' : 'pending';
  });

  retry(): void {
    if(this.on_cooldown()) return;

    this.attempts.update(v => v+1);

    this.auth.sync();

    this.on_cooldown.set(true);
    setTimeout(() => {
      this.on_cooldown.set(false);
    }, 5000);

  }

  constructor(){
    afterRenderEffect(() => {
      const user_package = this.auth.userSession()?.package;

      if(user_package == this.activated.snapshot.queryParams.p){
        this.router.navigate(['/post-checkout'], { queryParams: { success: 'true' }, queryParamsHandling: 'merge' });
      }

    });
  }
}
